import cx from 'classnames';
import { noop } from 'lodash-es';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './Hotspot.module.css';
export default function Hotspot(_a) {
    var _b;
    var height = _a.height, id = _a.id, isVisible = _a.isVisible, left = _a.left, onClick = _a.onClick, top = _a.top, width = _a.width, children = _a.children;
    var style = { left: left, top: top, width: width, height: height };
    return (React.createElement("div", { className: cx(styles.hotspot, (_b = {}, _b[styles.visibleHotspot] = isVisible, _b)), "data-testid": "hotspot-".concat(id), onClick: onClick, style: style }, children));
}
Hotspot.propTypes = {
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    isVisible: PropTypes.bool.isRequired,
    onClick: PropTypes.func.isRequired,
};
Hotspot.defaultProps = {
    onClick: noop,
};
